export default __webpack_public_path__ + "static/media/homepage.3bfc48cc.png";